import { Accordion } from "./Accordion";
import classes from '../../Styles/BearPeaks.module.css'
import KingDwarves from '../../../../images/Dwarves/HistoryBearPeaks/KingDwarves.webp'
import DwarfOnABear from '../../../../images/Dwarves/HistoryBearPeaks/DwarfOnABear.webp'
import DwarfAngry from '../../../../images/Dwarves/HistoryBearPeaks/DwarfAngry.webp'
import FloodedMines from '../../../../images/Dwarves/HistoryBearPeaks/FloodedMines.webp'
import DwarfMines from '../../../../images/Dwarves/HistoryBearPeaks/DwarfMines.webp'
import Forge from '../../../../images/Dwarves/HistoryBearPeaks/Forge.webp'
import DwarfExpedition from '../../../../images/Dwarves/HistoryBearPeaks/DwarfExpedition.webp'
import SapphireMountains from '../../../../images/Dwarves/HistoryBearPeaks/SapphireMountains.webp'
import OrcAttack from '../../../../images/Dwarves/HistoryBearPeaks/OrcAttack.webp'
import RowsOfDwarves from '../../../../images/Dwarves/HistoryBearPeaks/RowsOfDwarves.webp'



export const AccordionState = () => {
    const accordionItems = [
      {
        title: 'История Медвежьих вершин',
        content: (
<div className={classes.accordionItemContent}>
            <div className={classes.pictures}>
  <img title="Король Доронг Сапфир" src={KingDwarves} alt="Король Доронг Сапфир " className={classes.kingDwarves} draggable="false"/>
  <img title="Медвежьи Вершины" src={DwarfOnABear} alt="Вид на Горы где бродят медведи" className={classes.dwarvesKingdom} draggable="false"/>
</div>

 <div className={classes.contentScroll}>
  <h2>История Медвежьих вершин</h2>
    <p><strong>
      Во времена эпохи зимы гномы жили в предгорьях Медвежьих Вершин. Но когда континент стал оттаивать, земля начала проваливаться у них под ногами, образуя огромные расщелины и сеть подземных лабиринтов.
      По этим лабиринтам гномы и вышли в нагорья вершин, где они обнаружили большие залежи руды. К тому же в ущельях процветала жизнь: обитающая там фауна могла прокормить весь тогда ещё разрозненный народ вынужденных переселенцев. 
      Так гномы стали заселять эти нетронутые горы и тоннели. Множество общин старалось выбрать для себя более богатые и плодородные земли. Они враждовали между собой, пока Кунок Укротитель, глава одного из кланов, не открыл способ приручения медведей.
      Оседлавшие этих свирепых зверей гномы стали подчинять один за другим враждебные кланы. Многие даже не пытались сопротивляться и жаждали вступить в ряды новых хозяев гор. В итоге народ гномов объединился в один могучий клан, позже ставший королевством Медвежьих Вершин.
      Кунока Укротителя почитают во всех крепостях и поселениях как великого предка и спасителя народа гномов. Нынешний король Доронг Сапфир ведёт свой род от древнего прародителя.
      Именно он открыл гномам глаза на остальной мир и разрешил торговлю почти со всеми расами континента, разбив тем самым оковы тысячелетнего отрешения от других цивилизаций. Это, в свою очередь, позволило королевству стать одним из богатейших на всём Танахе.   
    </strong></p> 
</div>
          </div>
        ),
      },
      {
        title: 'Ночь Золотой паники',
        content: (
          <div>
           <div className={classes.pictures}>
    <img title="Гном из экспедиции кричит в гневе" className={classes.pictureLeft} src={DwarfAngry} alt="Гном из экспедиции кричит в гневе" draggable="false"/>
    <img title="Разрушенное предместье Медвежьих Вершин" className={classes.pictureRight} src={FloodedMines} alt="Озеро после Ночи Золотой паники" draggable="false"/>
  </div>
  <div className={classes.contentScroll} style={{position: "absolute", top: "45%"}}>
      <h2>Ночь Золотой паники</h2>
      <p><strong> 
        Пару веков назад, когда добыча золотоносной руды обрела сумасшедшие объёмы, прозванная золотой паникой, гномы погружались всё глубже в недра вершин в поисках богатых месторождений. 
        Они обнаружили на западе хребта, омываемом водами озера, подгорье с затопленными природными тоннелями. По берегам озера, у расщелин горы, было найдено множество золотоносного песка. 
        Тогда инженеры разработали план по отводу воды от тоннелей подгорья, построив защитные дамбы и опустошив подземелья от воды.
        Вокруг новых, наспех сооружённых рудников стало образовываться огромное поселение, куда стекались десятки артелей. Добыча велась алчно и неустанно, без внимания к опасениям инженеров. 
        Подземная добыча разрасталась стремительно: там, где вчера был камень и стены, уже на следующей неделе появлялась обширная сеть путей для вагонеток.
        Под озером находились пустоты, оставшиеся ещё со времён, когда Танах был покрыт льдом. 
        В ночь из-за перенаправления водного массива своды обрушились, и дамбы не выдержали, начав разрушаться. Потоки воды поглотили поселения предгорья и ринулись в рудники, снося всё на своём пути.
        Мощным накатом воды сети тоннелей стали обрушаться один за другим, утягивая за собой всё и вся. С такой мощью не смогла совладать даже сама гора, и отколовшаяся её часть рухнула, погребя под собой десятки тысяч гномов.
        Узнав о трагедии, король выслал экспедицию для поисков выживших. Но, прибыв на место, отряды обнаружили лишь вновь восстановившееся озеро, груды камней и останки поселения. Ландшафт горы изменился навсегда.
        После этого были приняты порядок и нормы выполнения работ по добыче ископаемых. Эта печаль останется в памяти гномов как Ночь Золотой Паники.
      </strong></p>
    </div>
          </div>
        ),
      },
      {
        title: 'Ремесло',
        content: (
          <div>
      <div className={classes.pictures}>
   <img title="Рудники Медвежьих Вершин" className={classes.pictureLeft}  src={DwarfMines} alt="Рудники гномов" draggable="false"/>
   <img title="Кузница Медвежьих Вершин" className={classes.pictureRight} src={Forge} alt="Гном работает в кузнице" draggable="false"/>
  </div>

  <div className={classes.contentScroll} style={{position: "absolute", top: "45%"}}>
        <h2>Ремесло</h2>
        <p><strong>
          Медвежьи Вершины славятся своей гильдией кузнецов и их качественной, тонкой работой. Оружие, доспехи, инструменты и предметы обихода - это не весь список изделий, которые подвластны мастерам кузнечного дела королевства. 
          Рудокопы постоянно ведут добычу, вне зависимости от времени суток, выплавляя тонны металла для поставки его в кузни.
          Заказы приходят один за другим со всего света, и спрос опережает предложение. Благодаря этому цена на товар из Медвежьих Вершин баснословная. К тому же гильдия торговцев идёт на всяческие ухищрения, чтобы ещё больше поднять цены.
          В Королевстве гномов всегда была лишь одна гильдия кузнецов. Её торговцам не нравилось, когда с их трудом обращаются как с второстепенной, посредственной задачей. 
          Они считали, что произвести товар - это полдела, а вот преподнести и продать его покупателю так, чтобы тот остался доволен и с пустыми карманами, - это и есть искусство.
          После долгих разбирательств и споров торговцы решили создать свою гильдию, где они оставляли бы себе часть золота с продаж. 
          Сначала их восприняли как шутов, но со временем обратили внимание, что торговля у них идёт полным ходом, а прибыль растёт вдвое у тех, кто к ним обратился. Так в королевстве появилась вторая гильдия. 
          Среди гномов есть также представители, незначительно отличающиеся физически от основной массы — часть расы, пошедшей по другому пути, потомки первых строителей и горняков.
          Народ Куркачи обладает высокой выносливостью и способен на длительную работу, будь то в шахтах или на любом другом тяжёлом поприще.
          Поговаривают, что вскоре и они потребуют создания своей гильдии.
        </strong></p>
      </div>

          </div>
        ),
      },
      {
        title: 'Королевский камень',
        content: (
          <div>
      <div className={classes.pictures}>
   <img title="Сапфировые озёра" className={classes.pictureLeft} src={SapphireMountains} alt="В горах виднеется синее свечение" draggable="false"/>
   <img title="Экспедиция гномов" className={classes.pictureRight} src={DwarfExpedition} alt="Экспедиция гномов" draggable="false"/>
  </div>

  <div className={classes.contentScroll} style={{position: "absolute", top: "45%"}}>
        <h2>Королевский камень</h2>
        <p><strong>
          В поисках ископаемых отправляются десятки, а то и сотни гномов. Но есть места, в которых не бывал ещё никто, ввиду их сложного ландшафта и суровых климатических условий. 
          Незадолго до своей коронации молодой Доронг вызвался добровольцем в одну из таких экспедиций. Они долго брели к отмеченному месту на карте, когда в горах неожиданно начался сильный буран. 
          В такой ситуации вся экспедиция должна была спуститься в базовый лагерь, но, видимо, что-то пошло не так, и часть гномов, в которой находился будущий король, откололась от основной группы.
          В непроглядной пелене снега они заблудились и решили разбить лагерь, чтобы переждать непогоду. Наутро, после того как всё закончилось и гномы выбрались из своих засыпанных снегом палаток, перед ними открылся удивительный пейзаж. 
          Пики вершин озарялись ярким солнцем, а на плато сияло синее горное озеро, окрашивая морозную дымку голубым оттенком. То были залежи сапфира, вросшие в лёд водоёма.
          Спустя недели поисков отколовшейся группы гномы из экспедиции потеряли надежду найти их живыми. Уже смирившись с утратой собратьев, они собирались возвращаться домой с печальной вестью. Но один из них заметил, как вдали показались фигуры среди зубцов заснеженных скал. 
          Когда их встретили, не могли поверить своим глазам. Измученные, с отёкшими лицами, они тащили на спинах туго набитые рюкзаки.
          Так были обнаружены сапфировые озёра, а сам камень стали называть королевским из-за трудностей, которые представляет его добыча. Немалую роль в этом названии сыграло и то, что в группе был сам Доронг, который также получил прозвище Сапфир.      
        </strong></p>
  </div>
          </div>
        ),
      },
      {
        title: 'Усмирение',
        content: (
          <div>
      <div className={classes.pictures}>
  <img title="Орк в тоннеле" className={classes.pictureLeft} src={OrcAttack} alt="Орк в тоннеле" draggable="false"/>
  <img title="Строй гномов" className={classes.pictureRight} src={RowsOfDwarves} alt="Строй гномов" draggable="false"/>
  </div>
  <div className={classes.contentScroll} style={{position: "absolute", top: "45%"}}>
        <h2>Тоннели</h2>
        <p><strong>
          Из южных шахт стали поступать противоречивые сообщения о появлении в тоннелях орков, грабящих тамошних трудяг. 
          Горняки устали терпеть бездействие руководства и направили посла во дворец с мольбой о помощи.
          До этих событий неприятности с зеленокожими уже происходили. Патрули у Чёрного Леса возвращались в неполном составе и рассказывали о зверских нападениях из Чернолесья. 
          А грабёж и нападения на караваны торговцев случались чуть ли не каждую неделю.
          Это не могло продолжаться вечно, иначе король потерял бы уважение своих подданных. 
          Узнав о беде, Доронг Сапфир решил положить конец этой угрозе и направил войска для усмирения агрессоров на юге - вплоть до полного уничтожения орков в лесах. По сути, это являлось объявлением войны.
          Тысячи гномов, встав под знамёна Медвежьих Вершин, направились стройными рядами к южным границам.
        </strong></p>
  </div>
          </div>
        ),
      }
    ];
  
    return (
      <div >
        <Accordion items={accordionItems} />
      </div>
    );
  }